import ApplicationController from "./application_controller"

// Generic checkbox -> AJAX PATCH persister with toast feedback, no page reload.
// Global (not page-scoped) -- used on both User Settings and Organization Settings
// Permissions tabs; promoted here from pages/user_settings since it has no
// page-specific logic of its own.
export default class extends ApplicationController {
  static values = { url: String, param: String }

  toggle(event) {
    const checkbox = event.target
    const checked = checkbox.checked
    const formData = new FormData()
    formData.append(this.paramValue, checked ? "1" : "0")

    const token = document.querySelector('meta[name="csrf-token"]')
    checkbox.disabled = true

    fetch(this.urlValue, {
      method: "PATCH",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/json",
        "X-CSRF-Token": token ? token.content : ""
      }
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        checkbox.disabled = false
        window.Gv3Toast.success("Preference updated.")
      })
      .catch(() => {
        checkbox.disabled = false
        checkbox.checked = !checked
        window.Gv3Toast.error("Could not update preference. Please try again.")
      })
  }
}
